export const partnerShipData = [
	'Заполните заявку. Выполните условия статуса партнёра .  Заключите договор о партнерстве',
	'Рекомендуете сервис Dinero знакомым и контрагентам',
	'Получаете вознаграждение за клиентов, использующих сервис Dinero',
	'Продолжаете рекомендовать Dinero, чтобы зарабатывать ещё больше'
];
